// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2ziia","requiredAsterisk":"Info_requiredAsterisk__14HIt"};